import { P2Role } from '@centric-os/types';

export const LOYALTY_ADMIN_ROLES: P2Role[] = [P2Role.ADMIN, P2Role.SYS_ADMIN, P2Role.SUPER_ADMIN];

export const LOYALTY_ALLOWED_ROLES: P2Role[] = [...LOYALTY_ADMIN_ROLES];
